'use strict'

let self

export default self = {
  container : document.querySelector('.detail-nav'),
  topOfNav : null,


  init : () => {
    window.addEventListener('scroll', self.debounce(self.fixNav));
    self.topOfNav = self.container.offsetTop - 50;
  },

  fixNav : () => {

    if(window.scrollY >= self.topOfNav){
        document.body.style.paddingTop = self.container.offsetHeight + 'px';
        self.container.classList.add('fixed-nav');
    } else {
        document.body.style.paddingTop = 0;
        self.container.classList.remove('fixed-nav');
    }

  },

  debounce : (func, wait = 10, immediate = true) => {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
}
